import { CommonModule } from "@angular/common";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { LoginComponent } from "../components/auth/login/login.component";
import { AuthRoutingModule } from "../routers/auth-routing-module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { createTranslateLoader } from "../app.module";
import { MatDialogModule } from "@angular/material/dialog";
import { AuthenticatorComponent } from "../components/auth/authenticator/authenticator.component";
import { ForgotPasswordComponent } from "../components/auth/forgot-password/forgot-password.component";
import { ActivationCodeComponent } from "../components/auth/activation-code/activation-code.component";
import { MfaLoginComponent } from "../components/auth/mfa-login/mfa-login.component";
import { MfaTranactionComponent } from "../components/auth/mfa-tranaction/mfa-tranaction.component";
import { MatRadioModule } from "@angular/material/radio";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { ChangePasswordComponent } from "../components/auth/change-password/change-password.component";
import { MatIconModule } from "@angular/material/icon";
import { ActivationComponent } from "../components/auth/activation/activation.component";
import { ResetPasswordComponent } from "../components/auth/reset-password/reset-password.component";
import { ProceedResetPwdComponent } from "../components/auth/proceed-reset-pwd/proceed-reset-pwd.component";

@NgModule({
    declarations: [
         LoginComponent,
         AuthenticatorComponent,
         ForgotPasswordComponent,
         ActivationCodeComponent,
         MfaLoginComponent,
         MfaTranactionComponent,
         ChangePasswordComponent,
         ActivationComponent,
         ResetPasswordComponent,
         ProceedResetPwdComponent
        ],
    imports: [
      CommonModule,
      ReactiveFormsModule,
      AuthRoutingModule,
      MatDialogModule,
      MatRadioModule,
      MatCheckboxModule,
      ReactiveFormsModule,
      MatIconModule,
      FormsModule,
      TranslateModule.forChild({
        loader: {
          provide: TranslateLoader,
            useFactory: createTranslateLoader, // exported factory function needed for AoT compilation
            deps: [HttpClient]
        },
      }),
     
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  })
  export class AuthModule { }